import * as EmailValidator from 'email-validator';
import passwordValidator from 'password-validator';

import { PASSWORD_MIN_LENGTH, PASSWORD_MAX_LENGTH } from 'constants/index';

export const getPasswordErrors = (password, confirm, dict = []) => {
    const passwordSchema = new passwordValidator();
    passwordSchema
        .is().min(PASSWORD_MIN_LENGTH)
        .is().max(PASSWORD_MAX_LENGTH)
        .has().symbols()
        .is().not().oneOf(dict)

    const errors = passwordSchema.validate(password, { list: true });

    if (confirm && confirm !== password) {
        errors.push('match');
    }

    return errors;
}

export const validatePassword = (password, confirm, dict) => {
    return getPasswordErrors(password, confirm, dict).length === 0;
}

export const validateEmail = email => EmailValidator.validate(email);

export const validateUrl = url => /[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,7}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/.test(url);
